module.exports = __webpack_public_path__ + "img/person-in-black-hand-sanitizer.2e570748.jpg";